import { Button, CurrencyFormat, Icon, Image } from '@/components/generic';
import { temporaryTiers } from '@/constants';
import { useTranslation } from 'react-i18next';

const Tier = ({
  tierData,
  setSelectedTier,
  scrollToCardTypes,
  btnHandler,
}: {
  tierData: any;
  setSelectedTier?: any;
  scrollToCardTypes?: () => void;
  btnHandler: (
    tierId: number | undefined
  ) => void;
}) => {
  const { t } = useTranslation();
  const handleBtn = () => {
    setSelectedTier(tierData?.id);
    scrollToCardTypes?.();
    btnHandler(tierData?.id);
  };

  return (
    <div
      className={`flex-1 max-w-100 pt-15 max-md:min-w-[280px] px-4 pb-10 max-lg:pt-8 max-lg:pb-7 max-md:flex-auto max-md:shrink-0 max-md:w-[280px] ${tierData?.id === 7
        ? 'relative border border-s-stroke2 rounded-[2.5rem]'
        : ''
        }`}
    >
      {tierData?.id === 7 && (
        <div className='absolute top-6 right-6 flex items-center justify-center size-16 pb-0.5 border border-s-stroke2 rounded-full max-lg:top-4 max-lg:right-4 max-lg:size-11'>
          <Icon className='fill-t-secondary' name='star-stroke-think' />
        </div>
      )}

      <div className='mb-8 pl-10 text-h4 max-lg:mb-5 max-lg:pl-5'>
        {tierData?.name}
      </div>
      <Image
        src={
          temporaryTiers[
            (tierData?.name as keyof typeof temporaryTiers) || 'Tier 0'
          ]?.img
        }
        alt='Card Image'
        className='mb-2 center '
      />
      <div
        className={`mb-8 px-10 py-6 border rounded-3xl max-lg:mb-5 max-lg:p-5 ${tierData?.id === 7
          ? 'border-s-stroke2 shadow-depth'
          : 'border-s-subtle'
          }`}
      >
        <div className='flex items-center justify-center mb-5 flex-col'>
          <div className='shrink-0 text-h3'>
            <CurrencyFormat
              value={
                temporaryTiers[
                  (tierData?.name as keyof typeof temporaryTiers) || 'Tier 0'
                ]?.annualPrice
              }
            />
          </div>
          <div className='grow pl-3 text-body-2 font-bold text-t-secondary'>
            {tierData?.name === 'Premium' || tierData?.name === 'Whale'
              ? t('newcard.two_year_price')
              : tierData?.id === 7
                ? t('newcard.lifetime_price')
                : t('newcard.annual_price')}
          </div>
        </div>
      </div>
      {!tierData?.disabled && (
        <Button isBlack onClick={() => handleBtn()} className='w-full mb-2'>
          {t('newcard.select_tier')}
        </Button>
      )}
      <div className='flex flex-col gap-4 px-10 max-lg:pl-5 max-lg:pr-0'>
        {temporaryTiers[
          (tierData?.name as keyof typeof temporaryTiers) || 'Tier 0'
        ]?.features?.map((feature: string, index: number) => (
          <div
            className='flex items-center gap-2 max-lg:gap-2 max-lg:text-body-2'
            key={index}
          >
            <Icon
              className={`${tierData?.id === 7 ? 'fill-t-primary' : 'fill-t-secondary/50'
                }`}
              name='check-circle-fill'
            />
            <div className='text-caption'>{feature}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tier;
